"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Component = _interopRequireDefault(require("../../Component"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _main = _interopRequireDefault(require("../templates/main"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Main =
/*#__PURE__*/
function (_View) {
  (0, _inherits2["default"])(Main, _View);

  function Main(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Main);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Main).call(this, props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "template", _main["default"]);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_getCoordinates", function (_ref) {
      var changedTouches = _ref.changedTouches;
      changedTouches = changedTouches || [];

      var _ref2 = changedTouches[0] || {},
          _ref2$clientX = _ref2.clientX,
          clientX = _ref2$clientX === void 0 ? null : _ref2$clientX,
          _ref2$clientY = _ref2.clientY,
          clientY = _ref2$clientY === void 0 ? null : _ref2$clientY;

      return {
        x: clientX,
        y: clientY
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onTouchStart", function (event) {
      var _this$_getCoordinates = _this._getCoordinates(event),
          x = _this$_getCoordinates.x;

      if (x !== null) {
        _this.x = x;
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onTouchEnd", function (event) {
      if (_this.x !== null) {
        var swipeDiff = _this.props.swipeDiff,
            diff = _this.x - _this._getCoordinates(event).x;

        if (Math.abs(diff) >= swipeDiff) {
          _this.navigate(Math.sign(diff));

          _this.x = null;
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_getDirection", function (active, to) {
      var length = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _react["default"].Children.count(_this.props.children);
      var dir = Math.sign(to - active);

      if (active === 0 && to === length - 1) {
        dir = -1;
      } else if (active === length - 1 && to === 0) {
        dir = 1;
      }

      return dir;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_moveSlide",
    /*#__PURE__*/
    function () {
      var _ref3 = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee(to) {
        var dir,
            active,
            nextState,
            _args = arguments;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dir = _args.length > 1 && _args[1] !== undefined ? _args[1] : null;
                active = _this.state.active;

                if (dir === null) {
                  dir = _this._getDirection(active, to);
                }

                nextState = {
                  active: to,
                  prevActive: active,
                  appearDirection: dir
                };

                if (_this.props.slideHeight !== null) {
                  nextState.slideHeight = 'auto';
                }

                _context.next = 7;
                return _this.setState(nextState);

              case 7:
                _this.autoPlay();

                return _context.abrupt("return", _this.setAnimation(true));

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "moveSlide",
    /*#__PURE__*/
    function () {
      var _ref4 = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee2(to, dir) {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this.state.animating) {
                  _context2.next = 7;
                  break;
                }

                if (!(typeof _this.props.onChange === 'function')) {
                  _context2.next = 5;
                  break;
                }

                _this.props.onChange(to);

                _context2.next = 7;
                break;

              case 5:
                _context2.next = 7;
                return _this._moveSlide(to, dir);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2, _x3) {
        return _ref4.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setAnimation",
    /*#__PURE__*/
    function () {
      var _ref5 = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee3(animating) {
        var additionalState,
            _args3 = arguments;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                additionalState = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
                _context3.next = 3;
                return _this.setState(_objectSpread({
                  animating: animating
                }, additionalState));

              case 3:
                if (typeof _this.props.onAnimationStateChange === 'function') {
                  _this.props.onAnimationStateChange(animating);
                }

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x4) {
        return _ref5.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "toSlide", function (to) {
      var active = _this.state.active,
          dir = Math.sign(to - active);

      _this.moveSlide(to, dir);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "navigate", function () {
      var dir = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var active = _this.state.active,
          children = _this.props.children;
      var to = active + dir;

      if (!children[to]) {
        if (dir > 0) {
          to = 0;
        } else if (dir < 0) {
          to = _react["default"].Children.count(children) - 1;
        }
      }

      _this.moveSlide(to, dir);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleAnimationEnd",
    /*#__PURE__*/
    function () {
      var _ref6 = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee4(e) {
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(e && e.currentTarget === e.target)) {
                  _context4.next = 3;
                  break;
                }

                _context4.next = 3;
                return _this.setAnimation(false, {
                  prevActive: _this.state.active
                });

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x5) {
        return _ref6.apply(this, arguments);
      };
    }());

    var _active = props.children[props.active] ? props.active : 0;

    _this.state = {
      // active slide
      active: _active,
      prevActive: _active,
      animating: false,
      // признак откуда выедет новость из слайдера (1| -1)
      appearDirection: 1
    };
    _this.x = null;
    _this.rootRef = _react["default"].createRef();
    return (0, _possibleConstructorReturn2["default"])(_this, (0, _assertThisInitialized2["default"])(_this));
  }

  (0, _createClass2["default"])(Main, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.autoPlay();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.autoPlay !== this.props.autoPlay) {
        this.autoPlay();
      }

      if (prevProps.active !== this.props.active) {
        this._moveSlide(this.props.active);
      }
    } // parameter - touchEvent

  }, {
    key: "autoPlay",
    value: function autoPlay() {
      var _this$props = this.props,
          autoPlay = _this$props.autoPlay,
          autoPlayInterval = _this$props.autoPlayInterval;
      clearInterval(this._autoPlayInterval);

      if (autoPlay) {
        this._autoPlayInterval = setInterval(this.navigate, autoPlayInterval);
      }
    }
  }]);
  return Main;
}(_Component["default"]);

(0, _defineProperty2["default"])(Main, "defaultProps", {
  active: null,
  showBullets: true,
  autoPlay: false,
  autoPlayInterval: 5000,
  timeout: 500,
  showNavigation: false,
  showCounter: false,
  handleSwipe: false,
  swipeDiff: 50,
  children: [],
  className: ''
});
(0, _defineProperty2["default"])(Main, "propTypes", {
  className: _propTypes["default"].string,
  children: _propTypes["default"].any,
  active: _propTypes["default"].number,

  /**
   * show bullets bar
   */
  showBullets: _propTypes["default"].bool,

  /**
   * change slide by interval
   */
  autoPlay: _propTypes["default"].bool,
  autoPlayInterval: _propTypes["default"].number,

  /**
   * switch between slides time
   */
  timeout: _propTypes["default"].number,

  /**
   * showing navigation arrows
   */
  showNavigation: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,

  /**
   * shows counter like: 1 of 5, 1 из 5, 1 з 5
   */
  showCounter: _propTypes["default"].bool,

  /**
   * flag to enable swipe handling
   */
  handleSwipe: _propTypes["default"].bool,

  /**
   * difference between touchStart and touchEnd to trigger navigation
   */
  swipeDiff: _propTypes["default"].number,

  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    /**
     * @default 0
     */
    padding: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.elDivider
     */
    borderColor: _propTypes["default"].string,

    /**
     * @default palette.elPrimary
     */
    background: _propTypes["default"].string,

    /**
     * @default palette.elSecondaryLight
     */
    bulletBackground: _propTypes["default"].string,

    /**
     * @default 0 ${palette.gutter * 2}px 0 0
     */
    bulletMargin: _propTypes["default"].string,

    /**
     * @default 9px
     */
    bulletWidth: _propTypes["default"].string,

    /**
     * @default 9px
     */
    bulletHeight: _propTypes["default"].string,

    /**
     * @default palette.elAccent
     */
    activeBulletBackground: _propTypes["default"].string,

    /**
     * @default palette.gutter * 2
     */
    counterPositionBottom: _propTypes["default"].number,

    /**
     * @default palette.gutter * 3
     */
    counterPositionRight: _propTypes["default"].number,

    /**
     * @default palette.tInversion
     */
    counterColor: _propTypes["default"].string,

    /**
     * @default 11.5px
     */
    counterBorderRadius: _propTypes["default"].string,

    /**
     * @default 0 ${palette.gutter}px
     */
    counterPadding: _propTypes["default"].string,

    /**
     * @default palette.elSecondaryLight
     */
    counterBackground: _propTypes["default"].string,

    /**
     * @default palette.tsNormal
     */
    counterFontSize: _propTypes["default"].string,

    /**
     * @default palette.tlNormal
     */
    counterLineHeight: _propTypes["default"].string,

    /**
     * @default 0 2px 3px rgba(0, 0, 0, 0.08), 0 0 3px rgba(0, 0, 0, 0.04)
     */
    counterTextShadow: _propTypes["default"].string,

    /**
     * @default palette.gutter * 6
     */
    navigationWidth: _propTypes["default"].number,

    /**
     * @default palette.gutter * 6
     */
    navigationHeight: _propTypes["default"].number,

    /**
     * @default 0
     */
    navigationBackPositionLeft: _propTypes["default"].number,

    /**
     * @default 50%
     */
    navigationBackPositionTop: _propTypes["default"].string,

    /**
     * @default 0
     */
    navigationNextPositionRight: _propTypes["default"].number,

    /**
     * @default 50%
     */
    navigationNextPositionTop: _propTypes["default"].string,

    /**
     * @default palette.elDivider
     */
    navigationBackground: _propTypes["default"].string,

    /**
     * @default arrowLeftImg
     */
    navigationBackIcon: _propTypes["default"].string,

    /**
     * @default arrowRightImg
     */
    navigationNextIcon: _propTypes["default"].string,

    /**
     * @default 1
     */
    navigationBorderRadius: _propTypes["default"].number,

    /**
     * @default 50
     */
    navigationZIndex: _propTypes["default"].number,

    /**
     * @default translateY(-50%)
     */
    navigationTransform: _propTypes["default"].string,

    /**
     * @default palette.elSecondaryLight
     */
    hoverNavigationBackground: _propTypes["default"].string
  })
});
(0, _defineProperty2["default"])(Main, "displayName", 'Slider');
var _default = Main;
exports["default"] = _default;